export const ORDER_STATUS = Object.freeze({
  CREATE: 'create',
  PROCESS: 'process',
  COMPLETE: 'complete',
  PRE_COMPLETE: 'pre_complete',
  SUCCESS: 'success',
  CANCEL: 'cancel',
  OK: 'ok',
  EXPIRED: 'expired',

  // For VIP order status
  VIP_PENDING: 'vip_pending',
  VIP_CONVERTED: 'vip_converted',
  VIP_EXPIRED: 'vip_expired',
})

export const CONFIRM_PAYMENT_PAY_AT_STORE_TYPE = Object.freeze({
  EDC_CREDIT_CARD: 'edc_credit_card',
  EDC_QR: 'edc_qr',
  CASH: 'cash',
})

export const CONFIRM_PAYMENT_ORDER_TYPE = Object.freeze({
  GENERAL: 'general',
  WITH_PLAN: 'with_plan',
  WITH_PLAN_TRADEIN: 'with_plan_tradein',
  WITH_TRADEIN: 'with_tradein',
  WITH_TRADEIN_LATER: 'with_tradein_later',
})

export const GUARANTEE_PAYMENT_STATUS = Object.freeze({
  CREATE: 'create',
  PROCESS: 'process',
  COMPLETED: 'completed',
})

// Trade-in type
export const TRADEIN_TYPE = Object.freeze({
  TRADEIN: 'tradein',
  BNTL: 'bntl',
  INTEREST: 'interest',
})

// Pre-Trade-in options
export const PRE_TRADE_IN_OPTIONS = Object.freeze([
  {
    label: 'เทรดเครื่องเก่าเป็นส่วนลดทันที',
    badgeLabel: 'นำเครื่องเก่ามาคืน ณ วันที่รับสินค้า',
    badgeColor: '#A3684E',
    desc: '',
    value: TRADEIN_TYPE.TRADEIN,
  },
  {
    label: `เทรดเครื่องเก่าเป็นคูปองเงินสดในระบบสมาชิก 7CLUB+ พร้อมรับ ส่วนลดเพิ่ม 2,500 บาท`,
    badgeLabel: ' Best offer!',
    badgeColor: '#0071BC',
    desc: `เมื่อนำเครื่องเก่ามาคืนที่สาขา ภายใน 5 วัน นับจากวันที่รับเครื่องใหม่`,
    value: TRADEIN_TYPE.BNTL,
  },
])

// Interest options
export const INTEREST_TRADE_IN_OPTIONS = Object.freeze([
  {
    label: 'สนใจ Trade-in ณ วันรับสินค้า',
    badgeLabel: null,
    badgeColor: null,
    desc: '',
    value: TRADEIN_TYPE.INTEREST,
  },
])

export default ORDER_STATUS
